// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hvVk","footer":"styles_footer__25i4o"};